import React from 'react';
import { getSubCategory } from 'day8-react/build/content';
import PageLayout from '../../layouts/page';
import FaqComponent, { FaqComponentType } from '../../components/faq/FaqComponent';
import { WpPageType } from '../../globalTypes';
import { NextPage } from 'next';

const Faq: NextPage<FaqComponentType> = ({ categories }) => {
  return (
    <PageLayout page={{ seo_title: 'Faqs | The Ski Week' }} hiddenCurrency>
      <FaqComponent categories={categories} />
    </PageLayout>
  );
};

export const getStaticProps = async () => {
  const categories = await getSubCategory(31);
  return {
    props: {
      categories: categories && categories
        .filter((item: WpPageType) => item.acf?.hidden !== true)
        .sort((a: WpPageType, b: WpPageType) => Number(b.acf?.order) - Number(a.acf?.order))
    },
    revalidate: 600
  };
};

export default Faq;